import { ProjectFormEnum } from 'shared'
import { createContext } from 'react'

interface ProjectFormIdentityContextProps {
  formEnum?: ProjectFormEnum
  projectId?: string
}

export const ProjectFormIdentityContext = createContext<ProjectFormIdentityContextProps>({})
